import { ReactComponent as LogoIcon } from '@app/assets/icons/logo-short.svg';
import backgroundImage from '@app/assets/images/feedback-banner-bg.webp';
import mobileBackgroundImage from '@app/assets/images/feedback-banner-mobile-bg.webp';
import { Button, ButtonStyle } from '@app/components';
import { useEnhancedTranslation, useMedia } from '@app/hooks';
import cx from 'classnames';
import { FC, useState } from 'react';
import { TFeedbackType } from '@app/api/models';
import { FeedbackForm } from './feedback-form';

import './feedback-banner.scss';

type FeedbackBannerProps = {
  className?: string;
  transparent?: boolean;
  entityId?: string;
  type?: TFeedbackType;
};

export const FeedbackBanner: FC<FeedbackBannerProps> = ({ className, transparent, entityId, type }) => {
  const { isMobile } = useMedia();
  const { t } = useEnhancedTranslation({ keyPrefix: 'feedback' });
  const [formVisible, setFormVisible] = useState(false);

  const content = (
    <>
      <h2 className="feedback-banner__title">{t('yourOpinion')}</h2>
      <p className="feedback-banner__description">{t('yourFeedback')}</p>
      <Button
        onClick={() => setFormVisible(true)}
        styling={ButtonStyle.ARROW}
        className="feedback-banner__open-form-btn"
      >
        {t('leaveFeedback')}
      </Button>
    </>
  );

  return (
    <>
      {transparent ? (
        <section className={cx(className, 'feedback-banner', 'feedback-banner--transparent')}>{content}</section>
      ) : (
        <section
          className={cx(className, 'feedback-banner')}
          style={{ backgroundImage: `url(${isMobile ? mobileBackgroundImage : backgroundImage})` }}
        >
          <div className="feedback-banner__content">{content}</div>
          <LogoIcon className="feedback-banner__logo" />
        </section>
      )}
      <FeedbackForm entityId={entityId} type={type} open={formVisible} onClose={() => setFormVisible(false)} />
    </>
  );
};
